import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Link, SegmentedControl, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplaneLanding, mdiAirplaneTakeoff } from '@mdi/js';
import { Icon } from '@mdi/react';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const ConfigStatusesPage = () => {
    const displayTypes = [
        "FIDS", "GIDS", "BIDS", "COUNTER"
    ]
    //const storeAdmin = useStoreAdmin();
    const [statuses, setStatuses] = useState<any[]>([]);
    const [selectedId, setSelectedId] = useState<string>("DEP");

    const { navigate } = useRouter();
    const { menu, idAirport } = useGlobalState();

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetStatuses();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleGetStatuses = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/config/statuses/list',
                },
                body: JSON.stringify({ orderBy: "tipo", order: "ASC", orderBy2: "statusES", order2: "ASC", columns: "idStatus, tipo, statusES, statusEN, jsonConfig" }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setStatuses(dataWeb.statuses);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        handleGetStatuses();
    }, []);

    const filtered = statuses.filter((status) => status.tipo.endsWith(selectedId));
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <SegmentedControl options={[
                            { text: 'Salidas', id: 'DEP' },
                            { text: 'Llegadas', id: 'ARR' },
                        ]}
                            selectedId={selectedId}
                            onChange={({ detail }) => setSelectedId(detail.selectedId)}
                        />


                    }>Estados</Header>
                    <Table
                        variant="borderless"
                        stickyHeader
                        items={filtered}
                        columnDefinitions={[
                            {
                                id: 'id', header: 'ID', cell: item => <Link href={`#config/statuses.edit?id=${item?.idStatus}`}>{item?.idStatus}</Link>,
                                width: 60
                            },
                            {
                                id: 'status', header: 'Dirección', cell: item => item?.tipo?.endsWith(".DEP") ? <Icon path={mdiAirplaneTakeoff} size={1} /> : <Icon path={mdiAirplaneLanding} size={1} />,
                                width: 60
                            },
                            {
                                id: 'description', header: 'Descripción', cell: item => <FormField label={item.statusES}>
                                    {item.statusEN}
                                </FormField>,
                            },
                            {
                                id: 'color', header: 'Color', cell: item =>
                                    <SpaceBetween direction='vertical' size='xs'>
                                        <BadgeCustom color={item.jsonConfig.colorBackground} textColor={item.jsonConfig.colorText}>ABC</BadgeCustom>
                                    </SpaceBetween>
                                ,
                                width: 130
                            },


                        ]}
                    />
                </SpaceBetween>
            }
        />
    )
};
